module.exports = __webpack_public_path__ + "img/breaking-color.dd58cfd.svg";